import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from './CAEJCurrentStatusToggler.module.css'
import Select from 'react-select'
import { de } from 'date-fns/locale'

const CAEJCurrentStatusToggler = (props) => {
    const { isOpen, onClose, jobIdentifier, defaultStatus, onSuccess } = props

    const authCtx = useContext(AuthContext)
    const [statusToUpdate, setStatusToUpdate] = useState(defaultStatus ||  '')
    const [isCurrentlyUpdating, setIsCurrentlyUpdating] = useState(false)
    const [jobCurrentStatus, setJobCurrentStatus] = useState([])

    // Update statusToUpdate when defaultStatus changes
    useEffect(() => {
        if (defaultStatus) {
            setStatusToUpdate(defaultStatus)
        }
    }, [defaultStatus])

    const toggleJobStatus = async () => {
        if (statusToUpdate !== '') {
            setIsCurrentlyUpdating(true)
            const toggleJobStatusResponse = await fetch(BASE_URL_API + "/toggleJobStatus",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        jobIdentifier: jobIdentifier,
                        statusToUpdate: statusToUpdate,
                        executiveIdentifier: authCtx.userIdentifier
                    })
                });

            if (!toggleJobStatusResponse.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const toggleJobStatusRespo = await toggleJobStatusResponse.json()
                if (toggleJobStatusRespo.status === "success") {
                    toast("Status updated successfully!")
                    onSuccess()
                    onClose()
                } else {
                    if (toggleJobStatusRespo.message === "token Expired, please login again!") {
                        authCtx.logout()
                    } else {
                        toast(toggleJobStatusRespo.message)
                    }
                }
                console.log(toggleJobStatusRespo)
            }
            setIsCurrentlyUpdating(false)
        } else {
            alert("Please select a valid status!")
        }
    }

    /// let's get the job current status from api getJobCurrentStatusOptions
    const getJobCurrentStatusOptions = async () => {
        const getJobCurrentStatusOptionsResponse = await fetch(BASE_URL_API + "/getJobCurrentStatusOptions",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token
                })
            });

        if (!getJobCurrentStatusOptionsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getJobCurrentStatusOptionsRespo = await getJobCurrentStatusOptionsResponse.json()
            if (getJobCurrentStatusOptionsRespo.status === "success") {
                setJobCurrentStatus(getJobCurrentStatusOptionsRespo?.response)
            } else {
                if (getJobCurrentStatusOptionsRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    toast(getJobCurrentStatusOptionsRespo.message)
                }
            }
        }
    }

    useEffect(() => {
        getJobCurrentStatusOptions()
    }, [])


    if (!isOpen) {
        return null
    } else {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        <div className={styles.mainHeader}>
                            Update the job current status!
                        </div>
                        <div className={styles.optionsWrapper}>

                            <Select
                                value={statusToUpdate ? { value: statusToUpdate, label: statusToUpdate } : null}
                                onChange={(selectedOption) => setStatusToUpdate(selectedOption.value)}
                                options={jobCurrentStatus?.map((status) => ({ value: status, label: status }))}
                                placeholder="Select Status"
                                styles={{ container: (provided) => ({ ...provided, width: 300 }) }}
                                maxMenuHeight={180}
                                searchable={true}
                            />

                        </div>
                        {isCurrentlyUpdating === false ?
                            <div className={styles.actionWrapper}>
                                <button className={styles.closeBtn} onClick={() => onClose()}>Close</button>
                                <button className={styles.updateBtn} onClick={() => toggleJobStatus()} >Done</button>
                            </div>
                            :
                            <div className={styles.actionWrapper}>
                                <button className={styles.closeBtn} onClick={() => alert("Please wait while I'm updating the status...")}>Close</button>
                                <button className={styles.updateBtn} >Updating...</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default CAEJCurrentStatusToggler